import { render, staticRenderFns } from "./positionDetails.vue?vue&type=template&id=17b187c6&scoped=true&"
import script from "./positionDetails.vue?vue&type=script&lang=js&"
export * from "./positionDetails.vue?vue&type=script&lang=js&"
import style0 from "./positionDetails.vue?vue&type=style&index=0&id=17b187c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b187c6",
  null
  
)

export default component.exports